// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YandexSplitBadge_wrapper__XccYB","loading":"YandexSplitBadge_loading__hQ8ZQ"};